import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"
import { ClientType } from "@prisma/client"
import { CreateClientTypeDto, FactsDescription, ListResponse, UpdateClientTypeDto } from "@dialogics/shared/dto/types"

export const callTypeApi = createApi({
  reducerPath: "callTypeApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/call-types/" }),
  tagTypes: ["CallType"],
  endpoints: builder => ({
    getCallTypesByDepartment: builder.query<(ClientType & { facts_description: FactsDescription })[], any>({
      query: params => ({
        url: "byDepartment",
        params,
      }),
    }),
    getCallTypesByOrganizationGroup: builder.query<ListResponse<ClientType>, { organizationGroupId: number }>({
      query: params => ({
        url: "byOrganizationGroup",
        params,
      }),
      providesTags: (result, error, arg) =>
        result
          ? [...result.results.map(({ id }) => ({ type: "CallType" as const, id })), { type: "CallType", id: "LIST" }]
          : [{ type: "CallType", id: "LIST" }],
    }),
    createCallType: builder.mutation<ClientType, CreateClientTypeDto>({
      query: body => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "CallType", id: "LIST" }],
    }),
    updateCallType: builder.mutation<ClientType, { id: number; data: UpdateClientTypeDto }>({
      query: ({ id, data }) => ({
        url: `${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: "CallType", id: arg.id }],
    }),
    deleteCallType: builder.mutation<ClientType, number>({
      query: id => ({
        url: `${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [{ type: "CallType", id: arg }],
    }),
    getCallType: builder.query<ClientType, number>({
      query: id => `${id}`,
      providesTags: (result, error, arg) => [{ type: "CallType", id: arg }],
    }),
  }),
})

export const {
  useGetCallTypesByDepartmentQuery,
  useGetCallTypesByOrganizationGroupQuery,
  useCreateCallTypeMutation,
  useUpdateCallTypeMutation,
  useDeleteCallTypeMutation,
  useGetCallTypeQuery,
} = callTypeApi
